import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-wrapper"
}
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr w-100" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    showClose: false,
    onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.close())),
    classes: "auto-height overflow-visible"
  }, {
    content: _withCtx(() => [
      ($props.listForUpdate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-title" }, "Edit lots details", -1)),
            _createElementVNode("form", {
              class: "default-form form-group",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Registration date", -1)),
                  _createVNode($setup["DatePicker"], {
                    modelValue: $setup.form.registrationDate,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.registrationDate) = $event)),
                    max: $setup.maxDate
                  }, null, 8, ["modelValue", "max"]),
                  ($setup.v$.registrationDate.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.registrationDate.required.$message), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 32),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "button default cancel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.close()))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary save",
                onClick: $setup.save
              }, "Save")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}